import { twMerge } from 'tailwind-merge';

import { CollapsibleFooterSection } from './CollapsibleFooterSection';
import { footerConfig } from './footer-config';
import styles from './Footer.module.scss';

export const Footer = ({ variant = 'default' }: { variant?: 'default' | 'referral' | 'events' }) => {
  return (
    <footer className={`${styles.footer} tw-mb-[40px] tw-grid tw-grid-cols-1 tw-gap-3.5 lg:tw-grid-cols-5 lg:tw-gap-8`}>
      {/* Products & Services */}
      <CollapsibleFooterSection
        title={footerConfig[0].title}
        items={footerConfig[0].items}
        className={twMerge(styles.section, styles.bottomBorder)}
        variant={variant}
      />

      {/* Games */}
      <CollapsibleFooterSection
        title={footerConfig[1].title}
        items={footerConfig[1].items}
        className={twMerge(styles.section, styles.bottomBorder)}
        variant={variant}
      />

      {/* CEXs & DEXs + NFT Marketplaces */}
      <div className={styles.section}>
        <CollapsibleFooterSection
          title={footerConfig[2].title}
          items={footerConfig[2].items}
          className={styles.bottomBorder}
          variant={variant}
        />
        <CollapsibleFooterSection
          title={footerConfig[3].title}
          items={footerConfig[3].items}
          className={twMerge(`tw-mt-3.5 lg:tw-mt-5`, styles.bottomBorder)}
          variant={variant}
        />
      </div>

      {/* About us */}
      <CollapsibleFooterSection
        title={footerConfig[4].title}
        items={footerConfig[4].items}
        className={twMerge(styles.section, styles.bottomBorder)}
        variant={variant}
      />

      {/* Organization + Medium Articles */}
      <div className={styles.section}>
        <CollapsibleFooterSection
          title={footerConfig[6].title}
          items={footerConfig[6].items}
          className={styles.bottomBorder}
          variant={variant}
        />
        <CollapsibleFooterSection
          title={footerConfig[7].title}
          items={footerConfig[7].items}
          className={twMerge(`tw-mt-3.5 lg:tw-mt-5`)}
          variant={variant}
        />
      </div>
    </footer>
  );
};
